import { useEffect, useState } from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';

function getTokenExpiration(jwt: string): Date | null {
  try {
    const payload = JSON.parse(atob(jwt.split('.')[1]));
    return payload.exp ? new Date(payload.exp * 1000) : null;
  } catch {
    return null;
  }
}

export function useIdTokenJwt() {
  const [idToken, setIdToken] = useState<string | null>(null);
  const [expiration, setExpiration] = useState<Date | null>(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const session = await fetchAuthSession();
        const jwt = session.tokens?.idToken?.toString();

        if (jwt) {
          setIdToken(jwt);
          setExpiration(getTokenExpiration(jwt));
        }
      } catch (error) {
        console.error('Erro ao buscar o ID Token:', error);
      }
    };

    fetchToken();
  }, []);

  return { idToken, expiration };
}

export async function getIdTokenJwt(): Promise<{ idToken: string | null, expiration: Date | null }> {
  try {
    const session = await fetchAuthSession();
    const jwt = session.tokens?.idToken?.toString();

    if (jwt) {
      const payload = JSON.parse(atob(jwt.split('.')[1]));
      const expiration = payload.exp ? new Date(payload.exp * 1000) : null;
      return { idToken: jwt, expiration };
    }

    return { idToken: null, expiration: null };
  } catch (error) {
    console.error('Erro ao buscar o ID Token:', error);
    return { idToken: null, expiration: null };
  }
}